import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Modal, Form, FormControl } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { getUserProfile, setUserRole } from "../../actions/userActions"
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { getSubdomainPath } from "../../utils/helpers";

const Popup = (props) => {

  const { handleSubmitCheckEmail, popUpLoader, setPopUpLoader, userInfo } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm();
  const [roleId, setRoleId] = useState("");
  const [isSSOEnabled, setIsSSOEnabled] = useState(null);
  const [isSSOLoading, setIsSSOLoading] = useState(true);

  const fetchSSOModeFromAPI = async () => {
    try {
      const response = await agent.get(API.SETTING);
      const ssoEnabled = response?.data?.data?.is_sso_enable === "1";
      setIsSSOEnabled(ssoEnabled);
    } catch (error) {
      console.error("Error fetching SSO settings:", error);
      setIsSSOEnabled(false);
    } finally {
      setIsSSOLoading(false);
    }
  }
  // Agreed workflow: only a NOT-eligible member has a fixed role (Mentee).
  // An eligible member chooses Mentor or Mentee in the dropdown (case 1).
  // A missing/unknown claim keeps today's behaviour (Mentee) — see the fix doc.
  const forcedRole =
    userInfo?.is_eligible_mentor === true ? null : "Mentees";
  const subDomainPath = getSubdomainPath();
  useEffect(() => {
    if (isSSOEnabled && forcedRole) {
      setValue("role_id", forcedRole, { shouldValidate: true });
      setRoleId(forcedRole);
      localStorage.setItem("userRole", forcedRole);
    }
  }, [isSSOEnabled, forcedRole, setValue]);
  useEffect(() => {
    fetchSSOModeFromAPI();
    // }, [props]);
  }, []);

  const ssoEmail =
    userInfo?.email ||
    decodeURIComponent(document.cookie
      .split("; ")
      .find(row => row.startsWith("sso_email="))
      ?.split("=")[1] || "");

  const isSSOEmail = Boolean(ssoEmail);

  useEffect(() => {
    if (isSSOEmail) {
      setValue("email", ssoEmail, { shouldValidate: true });
    }
  }, [isSSOEmail, ssoEmail, setValue]);

  const onSubmit = async (data) => {
    setPopUpLoader(true);

    const role = localStorage.getItem("userRole");

    if (role && isSSOEnabled) {
      await dispatch(setUserRole(role));
      await dispatch(getUserProfile());
    }

    handleSubmitCheckEmail(data);
  };

  const dispatch = useDispatch();

  const handleChange = (item) => {
    setRoleId(item);
    localStorage.setItem("userRole", item);
  };

  const isLoggedIn = Boolean(userInfo?.id);

  // Show modal if props.show is true (controlled by parent Home component)
  const shouldOpenModal = props.show

  if (isSSOLoading) {
    return (
      <>
        {props.show && (
          <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="calendar-modal"
            backdrop="static"
            keyboard={false}
            onHide={props.onHide}
          >
            <Modal.Header closeButton>
              {props.isSSOEnabled ? "Select Role For Registration" : "Enter email for registration"}
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex justify-content-center align-items-center py-4">
                <output aria-live="polite" className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </output>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </>
    );
  }

  return (
    <>
      {shouldOpenModal && (
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="calendar-modal"
          backdrop={isSSOEnabled ? "static" : true}
          keyboard={!isSSOEnabled}
          onHide={() => {
            localStorage.removeItem("userRole");   // ⭐ revert role
            props.onHide();
          }}
        >
          {isLoggedIn && !ssoEmail && !roleId ? <Modal.Header closeButton className="danger">Error!!</Modal.Header> : <Modal.Header closeButton onHide={() => {
            localStorage.removeItem("userRole");
            props.onHide();
          }}>{isSSOEnabled ? "Select Role For Registration" : "Enter email for registration"}</Modal.Header>}

          <Modal.Body>
            <div>
              {/* {!userInfo?.id ? */}
              {isLoggedIn && !ssoEmail && !roleId ? (
                "You are already logged In"
              ) : (
                <Form onSubmit={handleSubmit(onSubmit)} className="banner_form2 signup_class">



                 {isSSOEnabled && ['siduat', 'sid'].includes(subDomainPath) && forcedRole ? (
                    <>
                      <input type="hidden" {...register("role_id", { required: true })} />
                      <div className="form-control" style={{ background: "#f5f5f5", marginBottom: "0.5rem" }}>
                        You'll be registered as a <strong>Mentee</strong>.
                      </div>
                    </>
                  ) : (
                    <>
                     <select
                        {...register("role_id", { required: "Please select one option" })}
                        className={errors.role_id ? "form-control is-invalid" : "form-control"}
                        onChange={(e) => handleChange(e.target.value)}
                      >
                        <option value="">Please select role*</option>
                        <option value="Mentor">Mentor</option>
                        <option value="Mentees">Mentee</option>
                      </select>
                    </>
                  )}

                   
                      {errors.role_id && (
                        <label className="invalid-feedback text-left">{errors.role_id.message}</label>
                      )}

                  <Form.Group controlId="formEmail" style={{ marginTop: '1rem' }} className="mb-4">
                    <FormControl
                      type="email"
                      placeholder="Email Address"
                      className={errors?.email ? "formError" : ""}
                      disabled={isSSOEmail}
                      {...register("email", {
                        required: "Please enter your email address",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                        maxLength: {
                          value: 50,
                          message: "Your email should contain max 50 characters",
                        },
                      })}
                      aria-invalid={errors.email ? "true" : "false"}
                    />
                    {errors.email && (
                      <span role="alert" className="err_msg">
                        {errors.email.message}
                      </span>
                    )}
                  </Form.Group>

                  <div className="text-end">
                    <button type="submit" className={"btn loginsubmit btn-signup px-4 ms-auto"}>
                      {popUpLoader ? (
                        <output aria-live="polite" className="spinner-border">
                          <span className="visually-hidden">Loading...</span>
                        </output>
                      ) : (
                        "Register"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </div>
          </Modal.Body >
        </Modal>
      )}
    </>
  );
};

Popup.propTypes = {
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    email: PropTypes.string.isRequired
  }),
  handleSubmitCheckEmail: PropTypes.func.isRequired,
  popUpLoader: PropTypes.bool.isRequired,
  setPopUpLoader: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Popup;